import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => ({
  container: {
    display: "flex",
    justifyContent: 'space-between'
  },
  sectionHeader: {
    fontFamily: 'Roboto-Regular',
    fontSize: 16,
    color: '#4D4F5C',

    [theme.breakpoints.down('sm')]: {
      fontSize: 14
    }
  },
  sectionConclusion: {
    margin: '10px 0',
    padding: '10px 0',
    borderTop: '1px solid #E1E3E9'
  },
  totalWeight: {
    fontFamily: 'Roboto-Regular',
    fontSize: 16,
    color: 'rgb(94, 193, 78)',

    [theme.breakpoints.down('sm')]: {
      fontSize: 14
    }
  },
  warnTotal: {
    color: 'rgb(255, 0, 0)'
  },
  benchmarksContainer: {
    '& > div': {
      marginTop: 10
    }
  },
  section: {
    '&:nth-child(n+2)': {
    }
  },
  sectionDisabled: {
    filter: 'grayscale(1)',
    pointerEvents: 'none',
    cursor: 'initial'
  },
  acceptButton: {
    fontSize: 16,
    fontFamily: 'Roboto-Medium',
    borderRadius: 2,
    boxShadow: 'none',
    textTransform: 'none',
    width: 110,
    height: 40,

    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
      height: 'auto'
    }
  },
  benchmarkSelector: {
    display: 'flex',
    alignItems: 'center'
  },
  deleteBenchmark: {
    marginLeft: 8,
    marginRight: 14,
    color: theme.palette.primary.main,
    width: 22,
    height: 22,
    cursor: 'pointer'
  },
  checkbox: {
    padding: 5,
  },
  labelWrap: {
    marginLeft: 8,
    marginTop: 8,
    '& label': {
      margin: 0,
    },
  },
  parentLabel: {
    fontFamily: 'Roboto-Bold',
  },
  wrapper: {
    padding: 10,
    margin: 5,
    height: 'calc(100% - 10px)',
    backgroundColor: 'rgb(52 58 64 / 15%)',
  },
  wrapperLastItem: {
    padding: 5,
  },
  collapseWrapper: {
    marginTop: 5,
  },
  adaptableFontSize: {
    fontSize: 16,
    [theme.breakpoints.down('xs')]: {
      fontSize: 14
    },
  },
  collapseHeader: {
    fontSize: 16,
    fontFamily: 'Roboto-Bold',
    padding: "8px",
    cursor: 'pointer',
    background: '#eee',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  midLevelLabel: {
    fontSize: 16,
    padding: "8px",
    background: '#eee',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 5,
    '& label': {
      margin: 0,
    },
  },
  wrapperInner: {
    padding: '0 40px 15px',
    border: '1px solid #ccc',
    borderTop: 'none',
    [theme.breakpoints.down('sm')]: {
      padding: '0 8px 3px',
    },
  },
  collapseLabelRoot: {
    margin: 0,
  },
  collapseLabelItem: {
    margin: 0,
    fontFamily: 'Roboto-Bold',
  },
  collapseLabelItemMidLevel: {
    margin: 0,
  },
  closeButton: {
    position: 'absolute',
    top: 10,
    right: 10,
    [theme.breakpoints.down('sm')]: {
      top: 5,
      right: 5,
      padding: 8
    },
  },
}));
